import axios from "axios";
import { verifyToken } from "utils/Funciones";
import { BACKEND } from "utils/contants";
const API_URL = `${BACKEND}/api/cart/`;

const addToCart = async (formData, token) => {
    const response = await axios.post(API_URL, formData, {
        headers: {
            Authorization: 'Bearer ' + token
        },
    });
    return response.data;
};

const addToCartB = async (formData) => {
    const response = await axios.post(API_URL + 'addToCartB', formData, {
        headers: {
            Authorization: 'Bearer ' + verifyToken('userToken')
        },
    });
    return response.data;
};

const addToCartWhitBarCode = async (formData, token) => {
    const response = await axios.post(API_URL + 'whitbardcode', formData, {
        headers: {
            Authorization: 'Bearer ' + token
        },
    });
    return response.data;
};

const getMyCart = async (query, token) => {
    const response = await axios.get(API_URL + `${query}`, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
    });
    return response.data;
};

const getMyCartB = async (query) => {
    const response = await axios.get(API_URL + `getMyCartB${query}`, {
        headers: {
            Authorization: 'Bearer ' +  verifyToken('userToken'),
            'Content-Type': 'application/json'
        },
    });
    return response.data;
};

const removeFromCart = async (itemId, userId, token) => {
    const response = await axios.delete(API_URL + itemId + '/' + userId, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
    });
    return response.data;
};

const removeFromCartB = async (itemId, userId) => {
    try {
      const token = verifyToken('userToken');
  
      const response = await axios.delete(`${API_URL}removeFromCartB/${itemId}/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
  
      return response.data;
    } catch (error) {
      console.error('Error al eliminar del carrito:', error);
      throw error;
    }
  };
  

const clearCart = async (userId, token) => {
    const response = await axios.delete(API_URL + userId, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
    });
    return response.data;
};

const updateCartItemQty = async (formData, token) => {
    const response = await axios.patch(API_URL, formData, {
        headers: {
            Authorization: 'Bearer ' + token
        },
    });
    return response.data;
};

const applyDiscount = async (formData, token) => {
    const response = await axios.patch(API_URL + 'descuento', formData, {
        headers: {
            Authorization: 'Bearer ' + token
        },
    });
    return response.data;
};

const cartService = {
    addToCart,
    addToCartB,
    addToCartWhitBarCode,
    getMyCart,
    getMyCartB,
    updateCartItemQty,
    removeFromCart,
    removeFromCartB,
    clearCart,
    applyDiscount
};

export default cartService;
